import { useParams } from 'react-router-dom';
import NarrativeArcsView from './NarrativeArcsView';

/** Full-space canvas for one narrative arc (`/narrative-arcs/:slug`). */
export default function NarrativeArcDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  return <NarrativeArcsView focusSlug={slug} />;
}
